import axios from 'axios'
import { put } from 'redux-saga/effects'
import { APIRoute } from '../../../config'
import { LeaveTournamentAction } from '../actions'
import { LEAVE_TOURNAMENT_ACTION_SUCCESS } from '../constants'
import { TOURNAMENT_LOAD_PLAYERS, TOURNAMENT_TEAMS } from '@app/store/tournamentPlayers/constants'

function* leaveTournamentFlow({ tournamentId, authToken, lang, onComplete }: LeaveTournamentAction) {
  try {
    yield axios.delete(APIRoute.DELETE_LEAVE_TOURNAMENT(tournamentId), {
      params: {
        lang,
      },
      headers: { Authorization: `Bearer ${authToken}` },
    })
    yield put({ type: LEAVE_TOURNAMENT_ACTION_SUCCESS })
    yield put({
      type: TOURNAMENT_LOAD_PLAYERS,
      id: tournamentId,
    })
    yield put({
      type: TOURNAMENT_TEAMS,
      tournamentId,
    })

    onComplete(true)
  } catch (e) {
    onComplete(false, e)
  }
}

export default leaveTournamentFlow
